import React from 'react';

import MyRoutes from './router';

function App() {
  return <MyRoutes />;
}

export default App;
